module.exports = __webpack_public_path__ + "static/media/namecard_with_name.d1219f3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/namecard_with_name.svg
// module id = 2469
// module chunks = 71